import axios from "axios";
import Vue from "vue";
import enurl from "@/api/environment";

export const PAD_SESSION_EXPIRED_EVENT = "pad-session-expired";
const renewalClient = axios.create({ timeout: 10000 });
let renewalPromise = null;
let retryAfter = 0;

export function getSessionToken() {
  return Vue.$cookies.get("Token") || localStorage.getItem("Token");
}

export function isPadSession() {
  return window.location.pathname === "/MeetingRoomScreen" ||
    (window.location.pathname !== "/Login" &&
      Number(localStorage.getItem("roleID") || Vue.$cookies.get("roleID")) === 3);
}

function tokenExpiresAt(token) {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const expiresAt = Number(JSON.parse(window.atob(payload)).exp) * 1000;
    return Number.isFinite(expiresAt) ? expiresAt : 0;
  } catch (error) {
    return 0;
  }
}

function expiredError() {
  const error = new Error("Session ของจอหมดอายุ กรุณาให้เจ้าหน้าที่เข้าสู่ระบบใหม่");
  error.isSessionExpired = true;
  return error;
}

export async function renewPadSession() {
  const token = getSessionToken();
  const expiresAt = tokenExpiresAt(token || "");
  if (!token || expiresAt <= Date.now()) throw expiredError();
  if (expiresAt - Date.now() > 5 * 60 * 1000 || Date.now() < retryAfter) return token;

  if (!renewalPromise) {
    renewalPromise = renewalClient.post(`${enurl.apiUrl}Login/RenewPadToken`, null, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      // An old renewal must not restore a session after logout or another login.
      if (getSessionToken() !== token) throw new axios.Cancel("Session changed");
      const renewedToken = response.data?.data?.token;
      const renewedExpiry = tokenExpiresAt(renewedToken || "");
      if (response.data?.status !== 0 || renewedExpiry <= Date.now()) throw expiredError();
      Vue.$cookies.set("Token", renewedToken, new Date(renewedExpiry));
      Vue.$cookies.set("isLoggedIn", true, new Date(renewedExpiry));
      localStorage.setItem("Token", renewedToken);
      localStorage.setItem("isLoggedIn", "true");
      axios.defaults.headers.common.Authorization = `Bearer ${renewedToken}`;
      retryAfter = 0;
      return renewedToken;
    }).catch((error) => {
      if (getSessionToken() !== token) throw new axios.Cancel("Session changed");
      if (error.isSessionExpired || [401, 403].includes(error.response?.status) || expiresAt <= Date.now()) {
        throw expiredError();
      }
      // Keep a still-valid token during network/server failures without a retry storm.
      retryAfter = Date.now() + 60000;
      return token;
    }).finally(() => {
      renewalPromise = null;
    });
  }
  return renewalPromise;
}
